<template>
    <div id="index">
        <div
            is="ErrorBox"
            :errors="errors"
        >
        </div>
        <div v-if="is_initialized" class="contents">
            <h3 class="ui left floated header">

                {{ $t('ui.page_titles.assets') }}-{{category}}
            </h3>
            <router-link :to="{name: 'print_asset', params: {category: category}}" class="ui right floated basic button">
                {{ $t('ui.pages.assets.print_barcode') }}
            </router-link>
            <div v-if="assets.length < 1" class="ui icon message">
                <i class="warning icon"></i>
                <div class="content">
                    <div class="header">
                        {{ $t('ui.pages.assets.helps.no_anything_assets') }}
                    </div>
                    <p>
                        <!-- 點選左上新增資產按鈕建立 -->
                        {{ $t('ui.pages.assets.helps.please_clicked_upper_left_new_asset_button') }}
                    </p>
                </div>
            </div>
            <table v-else class="ui celled table">
                <thead>
                    <tr>
                        <th>{{ $t('models.attributes.assets.barcode') }}</th>
                        <th>{{ $t('models.attributes.assets.number') }}</th>
                        <th>{{ $t('models.attributes.assets.note') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <div
                    is="Item"
                    v-for="asset in assets"
                    :asset="asset"
                    ></div>
                </tbody>
            </table>
        </div>
        <div v-else>
            <div class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">
                    {{ $t('ui.general.initializing') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Item from './index/item.vue'
import ErrorBox from './errors.vue'
export default {
    name: "AssetsIndex",
    data() {
        return {
            is_initialized: false,
            assets: [],
            errors: []
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    computed: {
        category () {
            return this.$route.params.category
        },
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "assets_index") {
                this.init()
            }
        }
    },
    methods: {
        async init() {
            await this.fetch_assets()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_assets() {
            var url = this.$store.state.provider.routes.api_v1_provider_assets + "?category=" + this.$route.params.category
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.assets = response.data.assets
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.assets'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        }
    },
    components: {
        Item,
        ErrorBox
    }
}
</script>

<style scoped>
</style>
